import { render, staticRenderFns } from "./dam-sire-list-component.vue?vue&type=template&id=6c05a30e&scoped=true&lang=pug"
import script from "./dam-sire-list-component.js?vue&type=script&lang=js&external"
export * from "./dam-sire-list-component.js?vue&type=script&lang=js&external"
import style0 from "./dam-sire-list-component.vue?vue&type=style&index=0&id=6c05a30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c05a30e",
  null
  
)

export default component.exports